import { Hospital, ItemType, PanelDoctor } from 'all-in-one-shared-api';

export type ListItemData = {
  bookmarkId?: number;
  title1?: string;
  title1_cn?: string;
  title2?: string;
  title2_cn?: string;
  address?: string;
  address_cn?: string;
  phone?: string;
  itemId?: string;
  itemType: ItemType;
  latitude?: number;
  longitude?: number;
  data?: Partial<PanelDoctor & Hospital>;
};

export class MapDataUtils {
  static mapData = (data: Partial<PanelDoctor & Hospital>, bookmarkId?: number) => {
    return data.doctorClinicId
      ? MapDataUtils.mapDoctorData(data, bookmarkId)
      : MapDataUtils.mapHospitalData(data, bookmarkId);
  };

  private static mapDoctorData = (data: Partial<PanelDoctor>, bookmarkId?: number): ListItemData => ({
    title1: data.specialty,
    title2: data.doctorName,
    address: data.address,
    title1_cn: data.specialty_zh,
    title2_cn: data.doctorName_zh,
    address_cn: data.address_zh,
    phone: data.telephone,
    itemId: data.doctorClinicId,
    itemType: 'CLINIC',
    latitude: data.latitude,
    longitude: data.longitude,
    data: { ...data },
    bookmarkId: bookmarkId,
  });

  private static mapHospitalData = (data: Partial<Hospital>, bookmarkId?: number): ListItemData => ({
    title1: '',
    title2: data.name,
    title2_cn: data.name_zh,
    address: data.address,
    address_cn: data.address_zh,
    phone: data.telephone,
    itemId: data.hospitalId,
    itemType: 'HOSPITAL',
    latitude: data.latitude,
    longitude: data.longitude,
    data: { ...data },
    bookmarkId,
  });
}
